import PropTypes from "prop-types";

import { Box, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { formatNumber } from "@/features/shared";
import { ProductVariantNameCell } from "@/features/ui";

export const ProductVariantsSection = ({ salesInvoiceProductVariants }) => {
  if (!salesInvoiceProductVariants?.length) {
    return null;
  }

  const columns = [
    {
      field: "name",
      headerName: "Produk Varian",
      flex: 5,
      renderCell: ({ row: { name, sku } }) => (
        <ProductVariantNameCell name={name} sku={sku} />
      ),
    },
    {
      field: "quantity",
      headerName: "Qty",
      type: "number",
      flex: 1,
      valueFormatter: (value) => formatNumber(value),
    },
    {
      field: "unitOfMeasurement",
      headerName: "Unit",
      flex: 1,
      valueGetter: (_, row) => row.product?.unitOfMeasurement?.name || "-",
    },
    {
      field: "price",
      headerName: "Harga",
      type: "number",
      flex: 1.5,
      valueFormatter: (value) => formatNumber(value),
    },
    {
      field: "totalPrice",
      headerName: "Total",
      flex: 2,
      type: "number",
      valueGetter: (_, row) => row.quantity * row.price - row.discount,
      renderCell: ({ row }) => {
        const { quantity, price, discount } = row;
        const total = quantity * price - discount;
        const hasDiscount = discount && discount > 0;

        if (!hasDiscount) {
          return (
            <Typography variant="body2">{formatNumber(total)}</Typography>
          );
        }

        const originalTotal = quantity * price;

        return (
          <Box sx={{ py: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              {formatNumber(total)}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                textDecoration: "line-through",
                color: "text.secondary",
                fontSize: "0.7rem",
              }}
            >
              {formatNumber(originalTotal)}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "note",
      headerName: "Catatan",
      flex: 1.5,
      valueGetter: (_, row) => row.note || "-",
    },
  ];

  // Unwrapped: the page renders this inside the tab panel's own Paper, and the
  // "Faktur" tab already names it.
  return (
    <DataGrid
      getRowHeight={() => "auto"}
      columns={columns}
      rows={salesInvoiceProductVariants}
      disableRowSelectionOnClick
      hideFooter
      initialState={{
        sorting: {
          sortModel: [{ field: "name", sort: "asc" }],
        },
      }}
    />
  );
};

ProductVariantsSection.propTypes = {
  salesInvoiceProductVariants: PropTypes.array.isRequired,
};
